import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrentUrlService {
    public urlSource = new BehaviorSubject<string>('/tabs/dashboard/home');
    currentUrl = this.urlSource.asObservable();

    changeUrl(url: string){
        this.urlSource.next(url);
    }
}
